// extracted by mini-css-extract-plugin
export default {"container":"Sidebar__container___qS_Px","itemCount":"Sidebar__itemCount___G5ycV","dot":"Sidebar__dot___gY87P","skeleton-loading":"Sidebar__skeleton-loading___X2HDz"};